/**
 * Entry point.
 *
 * The stylesheets come from @hyphen/hyphen-components in the order it expects:
 * reset, then fonts, then the design tokens, then the component styles, then
 * ours. Getting that order wrong is how the components end up unstyled or
 * fighting the reset.
 */
import '@hyphen/hyphen-components/dist/css/reset.css';
import '@hyphen/hyphen-components/dist/css/fonts.css';
import '@hyphen/hyphen-components/dist/css/variables.css';
import '@hyphen/hyphen-components/dist/css/utilities.css';
import '@hyphen/hyphen-components/dist/css/index.css';
import './styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './views/app.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
